import { FlowStepHandleResult, HandleResultType, StepControl, AbstractStepController } from '@sdbn/common';
import { ContextChange } from '@sdbn/common';

export class InstructionTestController extends AbstractStepController {

  currentInstructionIndex = 0;
  instructionConfigurationIDs: Array<string>;
  maxAllowedFailures = 3;

  onContextChange(contextChange: ContextChange) {

    console.log('context changed', contextChange);

    if (contextChange.key === 'instruction-test-failure-count') {
      console.log(contextChange.value, this.maxAllowedFailures);
      if (contextChange.value > this.maxAllowedFailures) {
        const nextProcessStep = this.wizardComponent.currentStep.dashboardConfiguration?.testFailedTarget;
        console.log('forwarding to process', nextProcessStep);
        this.wizardComponent.next(nextProcessStep);
      }
    }
    if (contextChange.key === 'instruction-test-result') {
      if (contextChange.value === true) {

        this.currentInstructionIndex += 1;

        if (this.currentInstructionIndex >= this.instructionConfigurationIDs.length) {
          const nextProcessStep = this.wizardComponent.currentStep.dashboardConfiguration?.nextProcessStep;
          if (nextProcessStep == null) {
            this.wizardComponent.next();
          } else if (nextProcessStep === 'restart') {
            this.wizardComponent.restartWizard();
          } else {
            this.wizardComponent.next(nextProcessStep);
          }
        } else {
          this.dashboardContext.setContextValue('instructionConfigurationId', this.instructionConfigurationIDs[this.currentInstructionIndex])
        }

      } else {
        console.log('instruction-test-result is false: failed');
      }
    }
  }

  onRegisterToDashboardContext() {
    const config = this.wizardComponent.currentStep.dashboardConfiguration;
    this.instructionConfigurationIDs = config.instructionConfigurationIDs;
    if (config.maxAllowedFailures != null) {
      this.maxAllowedFailures = config.maxAllowedFailures;
    }
    if (config.profile != null) {
      this.dashboardContext.setContextValue('profile', config.profile);
    }
    this.dashboardContext.setContextValue('instructionConfigurationId', this.instructionConfigurationIDs[this.currentInstructionIndex]);
  }

  public handleFlow(): FlowStepHandleResult {
    this.wizardComponent.startInactivityMonitoring();
    const result = new FlowStepHandleResult();
    result.type = HandleResultType.DASHBOARD;
    return result;
  }

  getControls(): StepControl[] {
    return new Array<StepControl>();
  }
}
